'use client'

import Script from 'next/script'

declare global {
  interface Window {
    /*
     * `_mtm` is the Tag Manager API
     */
    _mtm: any[];
    /**
     * `_paq` is the low level JS tracker API (see https://forum.matomo.org/t/confusion-about-paq-push-and-mtm-push/56178)
     */
    _paq: any[];
  }
}

import { env } from '@/env'
import { useUser } from '@clerk/clerk-react'
import { Suspense, useEffect } from 'react'

/**
* Insert Matomo Tag Manager to track page views
* @docs https://developer.matomo.org/guides/spa-tracking
*/
export default function Matomo () {
  return (
    <>
      <Script
        id='matomo-container'
        src={`https://cdn.matomo.cloud/gesetzefinden.matomo.cloud/container_aEvKBgvb${env.NEXT_PUBLIC_VERCEL_ENV !== 'production' ? '_dev_690b41c73c4ef3b0339f19f5' : ''}.js?v3`}
        strategy='afterInteractive'
        onLoad={() => {
          // @ts-expect-error global var
          window.resolveMtmReady?.()
          console.log('Finished loading matomo script')
        }}
        onError={(error) => {
          console.log('Could not load Matomo script:', error)
          // @ts-expect-error global var
          window.resolveMtmReady?.()
        }}
      />
      <Suspense>
        <InitUserId />
      </Suspense>
    </>
  )
}

function InitUserId () {
  const { isLoaded, user } = useUser()
  const userId = user?.primaryEmailAddress?.emailAddress

  useEffect(() => {
    if (!isLoaded) return

    if (userId) {
      window._paq.push(['setUserId', userId]);
    } else {
      window._paq.push(['resetUserId']);
    }
  }, [isLoaded, userId])

  return null
}
